import UserTypeList from "./UserTypeList";
export default UserTypeList;
